import { render, staticRenderFns } from "./infodata.vue?vue&type=template&id=7c22bce8&scoped=true&"
import script from "./infodata.vue?vue&type=script&lang=js&"
export * from "./infodata.vue?vue&type=script&lang=js&"
import style0 from "./infodata.vue?vue&type=style&index=0&id=7c22bce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c22bce8",
  null
  
)

component.options.__file = "infodata.vue"
export default component.exports